// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1ufiC","content":"styles_content__1hcVY","icon":"styles_icon__1FV0i"};